import { render, staticRenderFns } from "./user-login.vue?vue&type=template&id=2b7eb4d1&scoped=true&"
import script from "./user-login.vue?vue&type=script&lang=js&"
export * from "./user-login.vue?vue&type=script&lang=js&"
import style0 from "./user-login.vue?vue&type=style&index=0&id=2b7eb4d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7eb4d1",
  null
  
)

export default component.exports